import(/* webpackMode: "eager", webpackExports: ["TopPlayerTable"] */ "/app/apps/web/src/components/leaderboard/top-player-table.tsx");
